import { SIZE } from 'baseui/spinner'
import SSBSpinner from './styled/SSBSpinner'
import StyledFormHeader from './styled/StyledFormHeader'
import SubscriptionStatusStep from './bones/SubscriptionStatus/SubscriptionStatusStep'
import useFormStatus from '../../../containers/SubscriptionFormPage/useFormStatus'

const FormHeader = () => {
  const { formIsLoaded } = useFormStatus()

  if (!formIsLoaded) {
    return (
      <StyledFormHeader>
        <SSBSpinner $size={SIZE.small} />
      </StyledFormHeader>
    )
  }
  return (
    <StyledFormHeader>
      <SubscriptionStatusStep />
    </StyledFormHeader>
  )
}

export default FormHeader
